import { useState } from "react";

const CustomDropdown = ({ options }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Address");

  const handleSelect = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  return (
    <div className="custom-dropdown" style={{ position: "relative", width: "200px", marginTop: "30px", marginRight: "20px" }}>
      {/* Selected Option */}
      <div
        className="dropdown-header"
        onClick={() => setIsOpen(!isOpen)}
        style={{
          backgroundColor: "#ffffff",
          color: "#111827",
          padding: "10px",
          borderRadius: "5px",
          cursor: "pointer",
          fontFamily: "Montserrat",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          border: "1px solid #ccc",
        }}
      >
        {selectedOption}
        <span style={{ marginLeft: "10px" }}>▼</span>
      </div>

      {/* Dropdown List */}
      {isOpen && (
        <ul
          className="dropdown-list"
          style={{
            position: "absolute",
            top: "100%",
            left: "0",
            width: "100%",
            backgroundColor: "#ffffff",
            listStyle: "none",
            padding: "0",
            margin: "5px 0",
            borderRadius: "5px",
            border: "1px solid #ccc",
            zIndex: 10,
          }}
        >
          {options.map((option, index) => (
            <li
              key={index}
              onClick={() => handleSelect(option)}
              style={{
                padding: "10px",
                cursor: "pointer",
                color: "#111827",
                borderBottom: "1px solid #eee",
                transition: "background 0.3s",
              }}
              onMouseEnter={(e) => (e.target.style.background = "#f0f4f8")}
              onMouseLeave={(e) => (e.target.style.background = "transparent")}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;